import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../helpers/export'
import BusinessYearsService from './service'

export const getBusinessYearsTable = createAsyncThunk(
  'companyAnalysis/industryOverview/businessYears/getBusinessYearsTable',
  async (params, { rejectWithValue }) => {
    try {
      const res = await BusinessYearsService.getBusinessYearsTable(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const exportBusinessYears = createAsyncThunk(
  'companyAnalysis/industryOverview/businessYears/exportBusinessYears',
  async (params) => {
    try {
      const res = await BusinessYearsService.exportBusinessYears(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
